import {Pipe, PipeTransform} from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the PadSkuPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'padSku',
})
export class PadSkuPipe implements PipeTransform {
  constructor(private vizixService: VizixService) {
  }

  transform(value: string) {
    if (this.vizixService.configurationApp.AppParametersConfiguration.AutoPadSKU.value) {
      while (value.length < Number(this.vizixService.configurationApp.AppParametersConfiguration.SKULength.value)) {
        value = "0" + value;
      }
    }
    console.log('Padded Sku: ' + value);
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/pad-sku.ts